import React from 'react';
import { MenuIcon } from 'lucide-react';
export function Navbar() {
  return <nav className="w-full bg-white border-b border-gray-100 sticky top-0 z-50" data-id="element-201">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <div className="flex justify-between items-center h-16" data-id="element-203">
          <div className="flex items-center" data-id="element-204">
            <img src="https://cdn.magicpatterns.com/uploads/1cYFozS8ELZrH7Sn9DrjdK/club_ahorra_positivo.png" alt="ClubAhorra" className="h-10" data-id="element-205" />
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-206">
            <a href="#beneficios" className="text-gray-600 hover:text-brand-600 font-medium transition-colors" data-id="element-207">
              Beneficios
            </a>
            <a href="#como-funciona" className="text-gray-600 hover:text-brand-600 font-medium transition-colors" data-id="element-208">
              Cómo funciona
            </a>
          </div>

          <div className="md:hidden" data-id="element-209">
            <button className="p-2 text-gray-600 hover:bg-gray-50 rounded-md" data-id="element-210">
              <MenuIcon className="h-6 w-6" data-id="element-211" />
            </button>
          </div>
        </div>
      </div>
    </nav>;
}